import { defineMessages } from 'react-intl';

export default defineMessages({
    TWIAWizardModalCancelTitle: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Cancel title',
        defaultMessage: 'Are you sure you want to exit?',
    },
    TWIAWizardModalCancelDescription: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Cancel description',
        defaultMessage: 'The information you entered will be stored as a draft quote. You must complete and submit this quote within 30 days of its Effective Date, or it will expire.',
    },
    TWIAWizardModalTitle: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Title',
        defaultMessage: 'Leave Page?',
    },
    TWIAWizardModalMessage: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Message',
        defaultMessage: 'The changes you have made on this page may be lost.',
    },
    TWIAWizardModalCancel: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Cancel',
        defaultMessage: 'Cancel',
    },
    TWIAWizardModalConfirm: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Confirm',
        defaultMessage: 'Yes',
    },
    TWIAQuoteTitle: {
        id: 'quoteandbind.wizard.residential.TWIA.title',
        defaultMessage: 'Quote Request',
    },
    TWIARenewalTitle: {
        id: 'quoteandbind.wizard.residential.TWIA.Renewal.title',
        defaultMessage: 'Renewal',
    },
    TWIAPolicyChangeTitle: {
        id: 'quoteandbind.wizard.residential.TWIA.Policy Change.title',
        defaultMessage: 'Policy Change',
    },
    TWIAPolicyChangeDraftTitle: {
        id: 'quoteandbind.wizard.residential.TWIA.Policy Change.draft.title',
        defaultMessage: 'Unable to Load Draft Policy Change',
    },
    TWIAPolicyChangeDraftError: {
        id: 'quoteandbind.wizard.residential.TWIA.Policy Change.drafterror',
        defaultMessage: 'Something went wrong during this process. Please try again.',
    },
    TFPAPolicyChangeDraftError: {
        id: 'quoteandbind.wizard.residential.TFPA.Policy Change.draft error tfpa',
        defaultMessage: 'An error occurred while attempting to load the policy change.',
    },
    TWIAWizardModalSave: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Save',
        defaultMessage: 'Save',
    },
    TWIAWizardModalNext: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Next',
        defaultMessage: 'Next',
    },
    newClaimSteps: {
        id: 'fnol.common.views.fnol.New Claim Steps',
        defaultMessage: 'New Claim Steps',
    },
    TWIAWizardModalCancelAddBuildTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.Modal.Cancel Adding Building?",
        defaultMessage: "Cancel Adding Building?"
    },
    TWIAWizardModalCancelAddBuildDescription: {
        id: "quoteandbind.wizard.commercial.TWIA.Modal.The information you have already provided about this building will be lost",
        defaultMessage: "The information you have already provided about this building will be lost. Are you sure you want to cancel?"
    },
    TWIAWizardModalCancel: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.No',
        defaultMessage: 'No',
    },
    TWIAWizardModalSaveBuilding: {
        id: 'quoteandbind.wizard.residential.TWIA.Modal.Save Building',
        defaultMessage: 'Save Building',
    },
    TWIACommonErrorMessage: {
        id: 'twia.quoteandbind.wizard.common.modal.twiaSubmitErrorMessage',
        defaultMessage: 'An error occurred while attempting to save. You may exit the transaction \nand try again. If you continue to receive this error please contact TWIA at \n(800) 788-8247.',
    },
    TWIAQuoteErrorMessage: {
        id: 'twia.quoteandbind.wizard.common.modal.twiaQuoteErrorMessage',
        defaultMessage: 'An error occurred while attempting to quote. You may exit the transaction \nand try again. If you continue to receive this error please contact TWIA at \n(800) 788-8247.',
    },
    unableToQuote: {
        id: 'quoteandbind.wizard.common.TWIA.Modal.unableToQuote',
        defaultMessage: 'Unable To Quote',
    },
    saveAndExit: {
        id: 'quoteandbind.wizard.common.TWIA.Modal.Save and Exit',
        defaultMessage: 'Save and Exit',
    },
    policyChangeCancelMessage: {
        id: "quoteandbind.wizard.commercial.TWIA.Modal.Policy",
        defaultMessage: "The information you entered will be saved as a draft. You must complete and submit this transaction within 30 days of its Effective Date, or it will expire."
    },
    wizardSideMenuModalCancel: {
        id: 'quoteandbind.wizard.sidemenu.common.Modal.Cancel',
        defaultMessage: 'Cancel',
    },
})